"use client";

import Input from "@/components/Elements/Input";
import Button from "@/components/Elements/Button";
import { useState } from "react";

interface SearchProps {
  placeholder?: string;
  searchType?: string;
}

export const Search = ({ placeholder = "Vad letar du efter?", searchType }: SearchProps) => {
  const [searchValue, setSearchValue] = useState("");
  const [hasError, setSetError] = useState(false);

  const doSearch = () => {
    if (!searchValue) {
      setSetError(true);
      return;
    }

    window.location.href = `/sok/?s=${searchValue}&t=auctionItems`;
  };

  const searchAuctionSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    doSearch();
  };

  return (
    <form className="input-group space-y-3 md:min-w-[400px] pt-[24px] w-full" onSubmit={searchAuctionSubmit}>
      <div
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <Input
          type="text"
          placeholder={placeholder}
          icon="search"
          iconOnClick={() => {
            doSearch();
          }}
          buttonSize="lg"
          iconClass="text-blue"
          fullWidth
          error={hasError}
          onKeyDown={() => setSetError(false)}
          onChange={(e) => setSearchValue(e.target.value)}
          inputClassName="placeholder:!text-[#8C8C8C] placeholder:md:!text-[20px]"
        />
      </div>
    </form>
  );
};
